import { 
  SET_CONTENT_HTML,
  ADD_SOURCE,
  ADD_LINK,
  SET_SOURCE_ORDER_INDEX,
  EDIT_SOURCE,
  SET_AUTH_DATA,
  SET_DOCS,
  SET_DOC_DATA,
  SET_DOC_SAVED,
  RENAME_DOC,
  CREATE_DOC,
  SET_CURRENT_DOC,
  UPDATE_CURRENT_DOC
 } from './mutation-types.js'
 import _ from 'lodash'

export default {
  [SET_CONTENT_HTML] (state, {contentHtml}) {
    state.contentHtml = contentHtml
  },

  [ADD_SOURCE] (state, {id, content}) {
    state.sources = {...state.sources, [id]: content}
  },
  [EDIT_SOURCE] (state, {content, sourceId}) {
    state.sources = {...state.sources, [sourceId]: _.cloneDeep(content)}
  },
  [SET_SOURCE_ORDER_INDEX] (state, {id, index}) {
    state.sources = {...state.sources, [id]: {...state.sources[id], orderIndex: index}}
  },

  [ADD_LINK] (state, {id, content}) {
    state.links = {...state.links, [id]: content}
  },

  [SET_AUTH_DATA] (state, { isAuthorized, authToken, profileName, userId }) {
    state.isAuthorized = isAuthorized
    state.authToken = authToken
    state.profileName = profileName
    state.userId = userId
  },

  [SET_DOCS] (state, docs) {
    state.docs = docs
  },
  [SET_DOC_DATA] (state, { content, sources, links }) {
    state.contentHtml = content
    state.sources = sources
    state.links = links
  },
  [SET_DOC_SAVED] (state, value)  {
    state.docSaved = value
  },
  [RENAME_DOC] (state, { oldDocName, newDocName }) {
    const isCrrentDoc = oldDocName === state.docName
    state.docs = state.docs.map((doc) => {
      if (doc.name === oldDocName) {
        return {...doc, name: newDocName}
      } else {
        return doc
      }
    })
    if (isCrrentDoc) {
      state.docName = newDocName
    }
  },
  [CREATE_DOC] (state, name) {
    state.docs.push({
      name,
      content: '',
      sources: {},
      links: {}
    })
  },
  [SET_CURRENT_DOC] (state, docName) {
    state.docName = docName
  },
  [UPDATE_CURRENT_DOC] (state) {
    state.docs = state.docs.map((doc) => {
      if (doc.name === state.docName) {
        return {
          ...doc,
          content: state.contentHtml,
          sources: state.sources,
          links: state.links
        }
      } else {
        return doc
      }
    })
  }
}


// WEBPACK FOOTER //
// ./src/vuex/mutations.js